<script setup lang="ts">
import type { TFilterItem } from '~/layers/catalog/data/types'
import type { PropType } from 'vue'

import FilterRuValuesSwitch from '~/layers/catalog/components/filter/FilterRuValuesSwitch.vue'
import { useCatalogStore } from '~/layers/catalog/store/catalog'

const props = defineProps({
  filter: {
    type: Object as PropType<TFilterItem>,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})

const store = useCatalogStore()
const service = useCatalogFilter()
const openedFilters = useState<Record<string, boolean>>('catalog-opened-filters', () => ({}))

const isActiveFilter = computed(() => {
  if (props.filter.code === 'categories') {
    return store.selectedCategories.length > 0
  }

  return service.get(props.filter.code) !== null
})

const isOpened = ref(openedFilters.value[props.filter.code] ?? isActiveFilter.value)

const toggle = () => {
  isOpened.value = !isOpened.value
  openedFilters.value[props.filter.code] = isOpened.value
}

watch(isOpened, (value) => {
  openedFilters.value[props.filter.code] = value
})

watch(
  () => props.filter.code,
  (code) => {
    isOpened.value = openedFilters.value[code] ?? isActiveFilter.value
  },
)

watch(isActiveFilter, (value) => {
  if (value) {
    isOpened.value = true
    openedFilters.value[props.filter.code] = true
  }
})
</script>

<template>
  <div :key="filter.code" :class="{ filters__item_open: isOpened }" class="filters__item">
    <div class="filters__header" :class="{ filters__header_nomrgn: index === 0 }" @click="toggle">
      <div class="filters__header-row">
        <p>{{ filter.title }}</p>
        <UTooltip v-if="filter.tooltip" :text="filter.tooltip" @click.stop />
      </div>
      <svg-icon class="filters__icon-arrow" height="16" name="down-arrow" width="16" />
    </div>

    <transition name="fade">
      <div v-show="isOpened" class="filters__form">
        <template v-if="filter.showParametersRussianMetricSystem">
          <FilterRuValuesSwitch :filter-code="filter.code" />
        </template>
        <slot />

        <div v-if="filter.showInvestmentDiamonds" class="border-main border-main__top">
          <a
            href="https://alrosaexclusive.ru/catalog/diamonds/"
            class="filters__link_banner border-main__bottom"
            target="_blank"
          >
            Посмотреть инвестиционные бриллианты более 2 карат без НДС
            <svg-icon height="20" name="icon-link" width="20"></svg-icon>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>
